<template>
  <div class="app-layout">
    <Sidebar @toggle-sidebar="toggleSidebar" :class="{ 'open': isSidebarOpen }" />
    <div class="main-content" :class="{ 'sidebar-open': isSidebarOpen }">
      <div class="mobile-header">
        <button class="menu-button" @click="toggleSidebar" aria-label="Toggle Menu">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
        <h1>Subscription Management</h1>
      </div>
      <subscription-list />
    </div>
  </div>
</template>

<script>
import SubscriptionList from '@/components/Subscription.vue';
import Sidebar from '@/components/Sidebar.vue';

export default {
  name: 'SubscriptionView',
  components: {
    SubscriptionList,
    Sidebar
  },
  data() {
    return {
      isSidebarOpen: false
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    }
  }
};
</script>

<style scoped>
.app-layout {
  display: flex;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.main-content {
  flex: 1;
  margin-left: 280px;
  padding: 20px;
  transition: margin-left 0.3s ease;
}

.mobile-header {
  display: none;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }

  .mobile-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 1rem;
  }

  .mobile-header h1 {
    margin: 0;
    font-size: 1.5rem;
    color: #2c3e50;
  }

  .menu-button {
    background: none;
    border: none;
    padding: 0.5rem;
    cursor: pointer;
    color: #2c3e50;
  }

  .menu-button svg {
    width: 24px;
    height: 24px;
  }

  .main-content.sidebar-open {
    margin-left: 0;
  }
}
</style> 